import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDayFunnelCloud: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M15.212 51.3444C11.6565 45.3888 10.2787 38.1444 11.7898 30.811C14.812 16.2777 28.2787 6.54438 42.7231 7.92216C43.7898 8.01105 44.8565 8.14438 45.9231 8.3666C47.0787 8.63327 48.1898 8.94438 49.2565 9.29994C47.3453 10.1888 45.5231 11.2555 43.9231 12.5444C39.6565 16.011 36.5453 20.8555 35.3453 26.6333C34.8565 28.9444 34.7231 31.2999 34.9453 33.5222C33.0787 35.5666 31.5231 37.9222 30.412 40.4999C23.7009 41.3888 18.012 45.5666 15.212 51.3444Z"
        fill="#D2D4DA"
      />
      <path
        d="M78.6345 54.6779H73.5678V49.7446C73.5678 38.8557 64.4567 30.0112 53.2567 30.0112C46.0123 30.0112 39.7012 33.7001 36.1012 39.2557C35.0345 40.9446 34.1901 42.8112 33.6567 44.8112H32.9456C25.9234 44.8112 20.0567 49.389 18.2789 55.6112C17.8789 56.9001 17.7012 58.2335 17.7012 59.6112C17.7012 67.789 24.5012 74.4557 32.9456 74.4557H78.6345C84.2345 74.4557 88.8123 70.0112 88.8123 64.5446C88.8123 59.1223 84.2345 54.6779 78.6345 54.6779Z"
        fill="#87D6F8"
      />
      <path
        d="M66.6352 78.8999L61.7463 92.1888H57.0352L61.8796 78.8999H66.6352Z"
        fill="#87D6F8"
      />
      <path
        d="M47.2564 78.8999L45.6564 83.2999H40.9453L42.5453 78.8999H47.2564Z"
        fill="#87D6F8"
      />
      <path
        d="M56.9454 78.8999L55.301 83.2999H50.5898L52.1898 78.8999H56.9454Z"
        fill="#87D6F8"
      />
      <path
        d="M48.9783 87.7778L47.3672 92.2112H52.1005L53.7116 87.7778H48.9783Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconDayFunnelCloud
